import { SentryLink } from "apollo-link-sentry";
import { env } from "@common/utils";

const sentryBreadcrumbsLink = new SentryLink({
  uri: `${env.apiUrl}/graphql`,
  setTransaction: true,
  setFingerprint: true,
  attachBreadcrumbs: {
    includeQuery: true,
    includeError: true,
    includeVariables: false,
    includeFetchResult: false,
    includeCache: false,
    includeContext: false,
  },
});

export { sentryBreadcrumbsLink };
